/**
 * GCC + extended Arab world country dial codes.
 * Used in onboarding/registration so users can only sign up with a
 * regional phone number. The first 6 are GCC + Yemen; the rest cover
 * the broader Arab world that Thqah also serves.
 */
export const GULF_COUNTRIES = [
  { code: "+966", iso: "SA", labelAr: "السعودية",      labelEn: "Saudi Arabia"        },
  { code: "+971", iso: "AE", labelAr: "الإمارات",       labelEn: "United Arab Emirates" },
  { code: "+974", iso: "QA", labelAr: "قطر",            labelEn: "Qatar"                },
  { code: "+965", iso: "KW", labelAr: "الكويت",         labelEn: "Kuwait"               },
  { code: "+973", iso: "BH", labelAr: "البحرين",        labelEn: "Bahrain"              },
  { code: "+968", iso: "OM", labelAr: "عُمان",           labelEn: "Oman"                 },
  { code: "+967", iso: "YE", labelAr: "اليمن",          labelEn: "Yemen"                },
  { code: "+962", iso: "JO", labelAr: "الأردن",         labelEn: "Jordan"               },
  { code: "+961", iso: "LB", labelAr: "لبنان",          labelEn: "Lebanon"              },
  { code: "+20",  iso: "EG", labelAr: "مصر",            labelEn: "Egypt"                },
  { code: "+964", iso: "IQ", labelAr: "العراق",         labelEn: "Iraq"                 },
];

/** Strict GCC-only list (6 states) used in the Login/Onboarding screens. */
export const GCC_ONLY = GULF_COUNTRIES.slice(0, 6);

export const DEFAULT_DIAL = "+966";

/**
 * Validate phone digits *after* the dial code.
 * Accepts 7–10 digit national numbers — covers all GCC + Arab world formats.
 */
export function isValidLocalNumber(digits) {
  if (!digits) return false;
  const clean = String(digits).replace(/\D+/g, "");
  return clean.length >= 7 && clean.length <= 10;
}

export function formatPhone(dial, local) {
  const clean = String(local || "").replace(/\D+/g, "").replace(/^0+/, "");
  return `${dial}${clean}`;
}
